<template>
  <div>
    <companiesMapPopup v-if="selectedObj"
                       :dataObj="selectedObj"
                       :year="year"
                       @close="closeDialog"></companiesMapPopup>
    <div id="cover" class="cover">
      <imageContainer class="image" :imageName="'SZY_9797'" :width="'100%'" :height="'100vh'"></imageContainer>
      <h1 v-html="title"></h1>
      <div @click="goToSection('#companies')" class="arrow white">
        <arrow-svg></arrow-svg>
      </div>
    </div>
    <div id="companies">
      <div id="map-wrapper">
        <div id="map"></div>
      </div>
      <div class="company-list">
        <ul>
          <li v-for="item in companiesData" :data-key="item.url">
            <router-link :to="getCompanyUrl(item.url)">{{item.title}}</router-link>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
  import companiesMapPopup from './../components/companiesMapPopup.vue'
  import imageContainer from './../components/imageContainer.vue'
  import arrowSvg from './../components/arrow.vue'
  import {scrollToSection} from '../utils'
  import poi from '../assets/gyarikon_piros-03.svg'

  export default {
    name: 'company',
    components: {
      companiesMapPopup,
      imageContainer,
      arrowSvg
    },
    data: function () {
      return {
        selectedObj: null,
        tileLayer: 'https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png',
        map: null,
      }
    },
    computed: {
      companiesData () {
        return this.$store.state.companies.companies
      },
      getCompanyUrl () {
        return (url) => `/company/${url}/${this.year}`
      },
      title () {
        return this.year === '2020' ? 'Látogatható<br>&nbsp;&nbsp;&nbsp; helyszínek' : 'Csatlakozó<br>&nbsp;&nbsp;&nbsp; Cégek'
      },
      year() {
        return this.$route.params.year
      }
    },
    watch: {
      companiesData: function(newVal, oldVal) {
        if (newVal) {
          this.initLayers()
        }
      },
      year: function(year, prevYear) {
        this.year = year;
        this.$store.dispatch('theme/getTheme', this.year);
        this.$store.dispatch('companies/getCompaniesData', this.year)
      }
    },
    methods: {
      goToSection (selector) {
        scrollToSection(selector)
      },
      openDialog (data) {
        this.selectedObj = data
      },
      closeDialog () {
        this.selectedObj = null
      },
      initMap () {
        this.map = L.map('map').setView([47.427, 19.056], 15.4)
        L.tileLayer(this.tileLayer, {
          maxZoom: 20,
          attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
        }).addTo(this.map)

        this.map.scrollWheelZoom.disable()
      },
      initLayers () {
        this.companiesData.forEach((data) => {
          const redIcon = new L.Icon({
            iconUrl: poi,
            iconSize: [45, 38],
            iconAnchor: [22, 38],
            popupAnchor: [1, -28],
            dragging: false
          })

          const marker = L.marker(data.coordinates, {icon: redIcon})

          data.leafletObject = marker.bindPopup(data.title)
            .on('mouseover', function () {
              this.openPopup()
            }).on('mouseout', function () {
              this.closePopup()
            }).on('click', (e) => {
              this.openDialog(data)
            }).addTo(this.map)
        })
      }
    },
    mounted () {
      this.initMap()

      if (this.year) {
        this.$store.dispatch('companies/getCompaniesData', this.year).then(data => {
          console.log(data, '-----daata')
          if (data) {
            this.initLayers()
          }
        })
      }
    },
    created() {
      this.$store.dispatch('theme/getTheme', this.year);
    }
  }
</script>

<style scoped>
  .cover {
    color: white;
    position: relative;
    height: 100vh;
    background: white;
  }

  .image {
    opacity: 0.8;
  }

  .cover h1, .cover h2 {
    position: absolute;
  }

  .cover h1 {
    right: 60px;
    top: 20vh;
    font-size: 70px;
    font-weight: 800;
    color: var(--colorB);
    text-transform: uppercase;
    margin-bottom: 10px;
    text-shadow: 2px 2px white;
  }

  @media (max-width: 600px) {
    .cover h1 {
      top: 14vh;
      right: 20px;
      font-size: 12vw;
      line-height: 1.2;
      text-align: right;
    }
  }

  #map-wrapper {
    width: 100%;
    height: 100vh;
  }

  @media (max-height: 500px) {
    #map-wrapper {
      height: 120vh;
    }
  }

  #map {
    width: 100%;
    height: 100%;
    opacity: 0.9;
  }

  .company-list {
    width: 100%;
    height: 66vh;
    border: 10px solid var(--colorB);
    box-sizing: border-box;
  }

  @media (max-width: 900px) {
    .company-list {
      height: 100vh;
    }
  }

  @media (max-height: 500px) {
  .company-list {
      height: 150vh;
    }
  }

  @media (max-width: 768px) {
    .company-list {
      height: auto;
    }
  }

  .company-list ul {
    display: flex;
    height: 100%;
    padding: 40px;
    flex-direction: column;
    flex-wrap: wrap;
    list-style: none;
  }

  .company-list li {
    position: relative;
    max-width: 250px;
    padding: 8px 10px 30px 0;
    margin: 0 2px;
    text-align: left;
    font-size: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }

  .company-list a {
    position: relative;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    font-weight: 600;
    color: var(--colorB);
  }

  .company-list a::after {
    position: absolute;
    content: '';
    width: 30px;
    height: 3px;
    left: 0;
    bottom: -15px;
    background-color: var(--colorA);
    transition: width .3s ease-in;
  }


  .company-list a:hover::after {
    width: 100%;
  }

  .arrow {
    position: absolute;
    bottom: 7vh;
    left: calc(50% - 15px);
    width: 30px;
    height: 30px;
    padding: 5px;
    font-size: 36px;
    color: var(--colorB);
    cursor: pointer;
    z-index: 2;
    border: 2px solid var(--colorB);
    box-sizing: border-box;
  }
</style>
